import { IdpConfig } from '../graphql/generated/autogenerated'
import {
    KEYCLOAK_SSO,
    parseAuthConfiguration,
    sortConfigsByPriority
} from '../utils/handleIdpConfig'

export function shouldForceSso({
    idpConfigs,
    email
}: {
    idpConfigs: Array<IdpConfig>
    email: string
}): boolean {
    const normalisedEmail = email.trim().toLocaleLowerCase() || ''
    const ssoIdps = idpConfigs?.filter((idpConfig) => {
        // temp for okta migration
        const authConfiguration = parseAuthConfiguration(
            idpConfig.configuration
        )
        if (authConfiguration.signInEnabled === false) {
            return false
        }

        return idpConfig.enabled !== false && idpConfig.idpType === KEYCLOAK_SSO
    })
    if (!ssoIdps.length) {
        return false
    }
    const sortedSsoIdps = sortConfigsByPriority(ssoIdps)
    const ssoConfig = sortedSsoIdps[0]
    const authConfiguration = parseAuthConfiguration(ssoConfig.configuration)
    const hasTopPriority = authConfiguration?.priority === 0
    const userHasEmailThatNeedsSso = ssoConfig?.emailAllowList?.some(
        (emailDomain) =>
            normalisedEmail.endsWith(emailDomain.trim().toLocaleLowerCase())
    )
    return hasTopPriority && userHasEmailThatNeedsSso
}

export default shouldForceSso
